module.exports = __webpack_public_path__ + "static/key-callcthulhu-a845cd8368d7115669fd9c374e13a47a.webp";